module.exports = __webpack_public_path__ + "img/add-all-icon.791a496f.svg";